import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import 'rxjs';
@Injectable()
export class EnvconfigService {
private _config!: any;
private _env!: string;
constructor(private _http: HttpClient) { }


LoadEnvironmentConfig(): Promise<any> {
  this._env = 'appsettings';
  return new Promise((resolve, reject) => {
    this._http.get('../../assets/config/' + this._env + '.json', { headers: {'Content-Type': 'application/json; charset=UTF-8'} })
     .subscribe({
      next: (response) => {
        this._config = response;
        resolve(true);
      },
      error: (error) => {
         console.error(error);
        reject(error);
      }
    });
  });
}

initializeAppTitle() {
  document.title = this.get("APPTITLE").toUpperCase();
}
  // Gets API route based on the provided key
  getApi(key: string): string {
  return this._config["API_ENDPOINTS"][key];
  }
  get(key: string): string {
    return this._config?.[key] ?? "";
  }
}
export function ConfigFactory(config: EnvconfigService) {
    return () => config.LoadEnvironmentConfig();
}